import { render, staticRenderFns } from "./ShopOrdOffers.vue?vue&type=template&id=a299aa2e&scoped=true&"
import script from "./ShopOrdOffers.vue?vue&type=script&lang=js&"
export * from "./ShopOrdOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a299aa2e",
  null
  
)

export default component.exports